import { BOOKSY_NOTIFICATION_TYPE } from './consts'

export const gtm1Notifications = {
  eventBooksyNotificationActionHandler ({ data }: {
    data: {
      screenName?: string
      eventAction?: string
      taskId?: string
    }
  }) {
    return {
      event: 'Business_Notification_Action',
      properties: {
        screen_name: data.screenName ?? null,
        event_action: data.eventAction ?? null,
        notification_type: BOOKSY_NOTIFICATION_TYPE,
        task_id: data.taskId ?? null,
      },
    }
  },
}
